export default __webpack_public_path__ + "build/dc745175f312dd2e666ca15010dff9ed.svg";